<template>
  <section id="team" class="py-5 dark-section">
    <div class="container text-center">
      <h2 class="mb-5">Das Team</h2>
      <div class="row justify-content-center">
        <div
            class="col-md-4 mb-4 slide-in-card"
            :class="{ 'slide-in-card-active': teamCardsVisible }"
            v-for="member in team"
            :key="member.id"
        >
          <div class="card shadow-sm h-100">
            <img :src="member.photo" :alt="member.name" class="card-img-top rounded-circle" />
            <div class="card-body d-flex flex-column align-items-center">
              <h5 class="card-title mb-10">{{ member.name }}</h5>
              <p class="card-subtitle">{{ member.role }}</p>
              <p class="card-text ">{{ member.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';

export default defineComponent({
  name: 'CompanyTeam',
  setup() {
    const team = ref([
      {
        id: 1,
        name: 'Dr.-Ing. André Pomp',
        role: 'Geschäftsführer',
        description:
            'André ist unser Visionär für Datenmanagement und künstliche Intelligenz. Mit seinem umfassenden Wissen über große Sprachmodelle gestaltet er innovative KI-Lösungen und führt ihr Unternehmen in die Zukunft.',
        photo: require('@/assets/team/andre.jpg'),
      },
      {
        id: 2,
        name: 'Dr.-Ing. Alexander Paulus',
        role: 'Geschäftsführer',
        description:
            'Alex ist der kreative Kopf hinter unseren Datenstrategien und Softwarelösungen. Er kombiniert fundiertes Wissen im Bereich Softwareentwicklung und -design, um herausragende digitale Erlebnisse zu schaffen.',
        photo: require('@/assets/team/alex.jpg'),
      },
    ]);

    const teamCardsVisible = ref(false);

    onMounted(() => {
      const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                teamCardsVisible.value = true;
                observer.disconnect();
              }
            });
          },
          { threshold: 0.1 }
      );

      const teamSection = document.querySelector('#team .row');
      if (teamSection) observer.observe(teamSection);
    });

    return { team, teamCardsVisible };
  },
});
</script>

<style scoped lang="less">
@import '../assets/style.less';

.card-img-top {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 50%;
  margin: 20px auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
 // border: 2px solid @accent-color;
}
</style>
